import { NavLink } from 'react-router-dom';
import React from 'react';

export const ChangeStatusButtons = props => {
  let content;
  if (props.status === 'WAITING') {
    content = (
      <>
        {props.hasRegistrationFee ? (
          <>
            <button
              className='btn btn-primary m-1'
              onClick={() => props.handleAcceptStatus(props.id)}
            >
              {locales('tables.approve')}
            </button>
            <NavLink
              className='btn btn-info m-1'
              to={{
                introducedCafe: true,
                pathname: '/cafes-contract/add',
                id: props.id,
                cafeCityCode: props.cafeCityCode,
                status: 'ACCEPTED_WITHOUT_REGISTRATION_FEE',
              }}
            >
              {locales('button.acceptWithoutPay')}
            </NavLink>
          </>
        ) : (
          <NavLink
            active={props.isPaidRegistrationFee}
            className='btn btn-primary m-1'
            to={{
              introducedCafe: true,
              pathname: '/cafes-contract/add',
              cafeCityCode: props.cafeCityCode,

              id: props.id,
              status: 'ACCEPTED',
            }}
          >
            {locales('titles.accept.and.submit.contract')}
          </NavLink>
        )}

        <button
          className='btn btn-warning m-1'
          onClick={props.handleStatusSelect}
        >
          {locales('label.first.rejection')}
        </button>
      </>
    );
  } else if (props.status === 'ACCEPTED_WITHOUT_REGISTRATION_FEE') {
    content = (
      <NavLink
        className='btn btn-success m-1'
        to={{
          introducedCafe: true,
          pathname: '/cafes/add',
          id: props.id,
          cafeCityCode: props.cafeCityCode,
          status: 'REGISTERED_WITHOUT_REGISTRATION_FEE',
        }}
      >
        {locales('label.registered.WithoutPay')}
      </NavLink>
    );
  } else if (props.status === 'ACCEPTED_WITHOUT_CONTRACT') {
    content = props.isPaidRegistrationFee ? (
      <NavLink
        active={props.isPaidRegistrationFee}
        className='btn btn-primary m-1'
        to={{
          introducedCafe: true,
          pathname: '/cafes-contract/add',
          cafeCityCode: props.cafeCityCode,

          id: props.id,
          status: 'ACCEPTED',
        }}
      >
        {locales('titles.submit.contract')}
      </NavLink>
    ) : (
      <button className='btn btn-secondary m-1' disabled>
        {locales('titles.submit.contract')}
      </button>
    );
  } else if (props.status === 'ACCEPTED') {
    content = (
      <NavLink
        className='btn btn-success m-1'
        to={{
          introducedCafe: true,
          pathname: '/cafes/add',
          id: props.id,
          cafeCityCode: props.cafeCityCode,

          status: 'REGISTERED',
        }}
      >
        {locales('label.registered')}
      </NavLink>
    )

  } else if (props.status === 'FIRST_REJECTION') {
    content = (
      <>
        {props.hasRegistrationFee ? (
          <>
            <button
              className='btn btn-primary m-1'
              onClick={() => props.handleAcceptStatus(props.id)}
            >
              {locales('tables.approve')}
            </button>
            <NavLink
              className='btn btn-info m-1'
              to={{
                introducedCafe: true,
                pathname: '/cafes-contract/add',
                id: props.id,
                cafeCityCode: props.cafeCityCode,
                status: 'ACCEPTED_WITHOUT_REGISTRATION_FEE',
              }}
            >
              {locales('button.acceptWithoutPay')}
            </NavLink>
          </>
        ) : (
          <NavLink
            active={props.isPaidRegistrationFee}
            className='btn btn-primary m-1'
            to={{
              introducedCafe: true,
              pathname: '/cafes-contract/add',
              cafeCityCode: props.cafeCityCode,

              id: props.id,
              status: 'ACCEPTED',
            }}
          >
            {locales('titles.accept.and.submit.contract')}
          </NavLink>
        )}

        <button
          className='btn btn-danger m-1'
          onClick={props.handleStatusSelect}
        >
          {locales('label.final.rejection')}
        </button>
      </>
    );
  }

  return (
    <>
      {props.status !== 'FINAL_REJECTION' && props.status !== 'REGISTERED' && (
        <div className='col-12 p-0 d-flex my-4'>
          <div className='col-2'>{locales('tables.changeStatus')} :</div>
          <div className='col-10 d-flex'>{content}</div>
        </div>
      )}
    </>
  );
};
